/**
 * Scope Contas virtuais rows to the active IB account's entity.
 * Nominal PF (pers_…) must not see Valut LLC (enti_…) virtuals that are tagged.
 * Exit-rail rows still missing entity_id (legacy seed) are shown only under enti_…
 * scope so Contas virtuais is not empty after backend OwnerEntityId / AccountType fixes.
 */

export const resolveAccountEntityId = (account) =>
  String(
    account?.entityId
      || account?.raw?.entity_id
      || account?.raw?.entityId
      || "",
  )
    .trim() || null;

const isBusinessEntityScope = (entityId) =>
  /^enti_/i.test(String(entityId || "").trim());

/**
 * @param {object[]} accounts mapped IB accounts (may include virtuals)
 * @param {string|null|undefined} activeEntityId
 * @param {(account: object) => boolean} isVirtual
 */
export const filterVirtualAccountsByActiveEntity = (
  accounts,
  activeEntityId,
  isVirtual,
) => {
  const list = Array.isArray(accounts) ? accounts : [];
  const virtuals = list.filter((account) => isVirtual(account));
  const entityId = String(activeEntityId || "").trim();

  // Without an active entity we cannot safely attribute LLC virtuals — show none.
  if (!entityId) return [];

  const allowUnscopedExitRail = isBusinessEntityScope(entityId);

  return virtuals.filter((account) => {
    const rowEntity = resolveAccountEntityId(account);
    if (!rowEntity) return allowUnscopedExitRail;
    return rowEntity.localeCompare(entityId, undefined, { sensitivity: "accent" }) === 0;
  });
};
